module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-slide-3-90ce3c90d32e1b8b1f5693b1e7f104ed.png";